import { Notify } from 'quasar'

Notify.setDefaults({
  position: 'top',
  textColor: 'white'
})

export default ({ Vue }) => {
  Notify.error = (message, position = 'top') => {
    Notify.create({
      color: 'red-5',
      message,
      position,
      icon: 'eva-alert-circle-outline',
      actions: [{ icon: 'eva-close', handler: Function, color: 'white' }]
    })
  }

  Notify.success = (message, position = 'top') => {
    Notify.create({
      color: 'green-6',
      message,
      position,
      icon: 'eva-checkmark',
      actions: [{ label: 'Cerrar', handler: Function, color: 'white' }]
    })
  }

  Notify.warning = (message, position = 'top') => {
    Notify.create({
      color: 'yellow-9',
      message,
      position,
      icon: 'eva-alert-triangle-outline',
      actions: [{ label: 'Cerrar', handler: Function, color: 'white' }]
    })
  }

  Notify.default = (message, position = 'top') => {
    Notify.create({
      color: 'green-6',
      message,
      position,
      icon: 'eva-checkmark',
      actions: [{ label: 'Cerrar', handler: Function, color: 'white' }]
    })
  }
  Vue.prototype.$notify = Notify
}
